import { createSelector } from '@ngrx/store';
import { selectAllVehicles } from 'src/store/entityStores/entity-store-selectors';
import { selectUnitById } from 'src/store/generated/unit-record.generated';
import { selectUnitsByCompany } from './unit-selectors';
import { selectVehiclesByCompany } from './vehicle-selectors';

export function selectVehiclesUnassignedToUnitsByCompany(companyId: string, includeId?: string) {
  return createSelector(
    selectVehiclesByCompany(companyId),
    selectUnitsByCompany(companyId),
    (vehicles, units) => {
      return vehicles.filter((v) => {
        return units.find((u) => u.vehicleId === v.id) == null || v.id === includeId;
      });
    },
  );
}

export function selectVehicleByUnitId(unitId: string) {
  return createSelector(selectUnitById(unitId), selectAllVehicles, (unit, vehicles) => {
    return unit != null && unit.vehicleId != null ? vehicles.get(unit.vehicleId) : undefined;
  });
}
